<div class="mt-50">
  <div class="container">
    <div class="row is-flex">
      <div class="col s12 text-center">
        <h6>Thank you for your order!</h6>
        <p>Your order confirmation number is: {{confirmationNo}}</p>
        <button class="btn btn-secondary" routerLink="/catalog">Return to Search >></button>
      </div>
    </div>
  </div>
</div>
